var map = {
	"./adsimple/140.svg": [
		7785,
		7785
	],
	"./adsimple/40.svg": [
		6613,
		6613
	],
	"./adsimple/48.svg": [
		1284,
		1284
	],
	"./arrows/down/16.svg": [
		6996,
		6996
	],
	"./arrows/down/24.svg": [
		154,
		154
	],
	"./arrows/down/32.svg": [
		3943,
		3943
	],
	"./arrows/left/32.svg": [
		5592,
		5592
	],
	"./arrows/right/16.svg": [
		9648,
		9648
	],
	"./arrows/right/24.svg": [
		3942,
		3942
	],
	"./arrows/right/28.svg": [
		9051,
		9051
	],
	"./arrows/right/32.svg": [
		8088,
		8088
	],
	"./arrows/up/24.svg": [
		4129,
		4129
	],
	"./card/20.svg": [
		6912,
		6912
	],
	"./check/28.svg": [
		6685,
		6685
	],
	"./checkmark/16.svg": [
		4881,
		4881
	],
	"./checkmark/24.svg": [
		9782,
		9782
	],
	"./checkmark/32.svg": [
		5558,
		5558
	],
	"./cross/24.svg": [
		2801,
		2801
	],
	"./cross/32.svg": [
		3435,
		3435
	],
	"./emoji/fingerup/40.svg": [
		4859,
		4859
	],
	"./emoji/fire/16.svg": [
		9269,
		9269
	],
	"./emoji/fire/24.svg": [
		8262,
		8262
	],
	"./emoji/fire/36.svg": [
		5,
		5
	],
	"./emoji/smart/40.svg": [
		8080,
		8080
	],
	"./flash/28.svg": [
		6763,
		6763
	],
	"./gramophone/20.svg": [
		5235,
		5235
	],
	"./information/16.svg": [
		9127,
		9127
	],
	"./information/24.svg": [
		5757,
		5757
	],
	"./information/32.svg": [
		6682,
		6682
	],
	"./menu/16.svg": [
		3383,
		3383
	],
	"./menu/24.svg": [
		9810,
		9810
	],
	"./menu/32.svg": [
		9180,
		9180
	],
	"./networks/bg/coin.svg": [
		2900,
		2900
	],
	"./networks/bg/dollar1.svg": [
		4093,
		4093
	],
	"./networks/bg/dollar2.svg": [
		7313,
		7313
	],
	"./networks/bg/high-risk.svg": [
		9206,
		9206
	],
	"./networks/facebook-high-risk/facebook-high-risk.svg": [
		9410,
		9410
	],
	"./networks/google-high-risk/google-high-risk.svg": [
		4659,
		4659
	],
	"./partners/bigo-ads.svg": [
		7720,
		7720
	],
	"./partners/google-ads.svg": [
		7555,
		7555
	],
	"./partners/meta.svg": [
		2042,
		2042
	],
	"./partners/petal-ads.svg": [
		5959,
		5959
	],
	"./partners/search-ads.svg": [
		6126,
		6126
	],
	"./partners/snapchat.svg": [
		8164,
		8164
	],
	"./partners/telegram.svg": [
		4440,
		4440
	],
	"./partners/tik-tok.svg": [
		6558,
		6558
	],
	"./payments/mastercard.svg": [
		2869,
		2869
	],
	"./payments/visa.svg": [
		393,
		393
	],
	"./plus/24.svg": [
		4168,
		4168
	],
	"./send-message/20.svg": [
		4077,
		4077
	],
	"./social/facebook.svg": [
		3555,
		3555
	],
	"./social/telegram.svg": [
		5781,
		5781
	],
	"./social/vk.svg": [
		2332,
		2332
	],
	"./social/youtube.svg": [
		1237,
		1237
	],
	"./spinner/16.svg": [
		4370,
		4370
	],
	"./status/error1/16.svg": [
		2665,
		2665
	],
	"./status/info/16.svg": [
		6843,
		6843
	],
	"./time-clock/20.svg": [
		883,
		883
	],
	"./user/16.svg": [
		1869,
		1869
	],
	"./user/20.svg": [
		9941,
		9941
	],
	"./user/24.svg": [
		7541,
		7541
	],
	"./user/28.svg": [
		1135,
		1135
	],
	"./user/32.svg": [
		2596,
		2596
	],
	"./users/20.svg": [
		9687,
		9687
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 4023;
module.exports = webpackAsyncContext;